"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, ReactNode, useMemo } from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropLocation } from "./Drop";
interface DropContextType {
  drop: ExtendedDrop | null;
  location: DropLocation;
}
const DropContext = createContext<DropContextType | undefined>(undefined);
interface DropProviderProps {
  readonly children: ReactNode;
  readonly drop: ExtendedDrop | null;
  readonly location: DropLocation;
}
function DropProvider(t0) {
  const $ = _c(6);
  const {
    children,
    drop,
    location
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== location) {
    t1 = {
      drop,
      location
    };
    $[0] = drop;
    $[1] = location;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const memoizedValue = t1;
  let t2;
  if ($[3] !== children || $[4] !== memoizedValue) {
    t2 = <DropContext.Provider value={memoizedValue}>{children}</DropContext.Provider>;
    $[3] = children;
    $[4] = memoizedValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function useDropContext() {
  const context = useContext(DropContext);
  if (context === undefined) {
    throw new Error("useDropContext must be used within a DropProvider");
  }
  return context;
}
export default DropContext;